module.exports = __webpack_public_path__ + "img/4.86c77bf5.jpg";